import { defineColumn } from '../../../components/tanstack-table/column';
import { TanStackTable } from '../../../components/tanstack-table/table';
import type { UnparsedRow } from '../../../data/receiving';

const INVALID_ROW_COLUMNS = [
  defineColumn<UnparsedRow>({
    id: 'File',
    minWidth: 180,
    maxWidth: 320,
    accessorFn: (r) => r.filename,
  }),
  defineColumn<UnparsedRow>({
    id: 'Row',
    minWidth: 50,
    maxWidth: 80,
    accessorFn: (r) => String(r.row),
    sortingFn: (a, b) => a.row - b.row,
  }),
  defineColumn<UnparsedRow>({
    id: 'Error',
    minWidth: 200,
    maxWidth: 640,
    accessorFn: (r) => r.err,
  }),
];

export function InvalidRowsTable({ rows }: { rows: UnparsedRow[] }) {
  return <TanStackTable data={rows} columns={INVALID_ROW_COLUMNS} />;
}
